import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface SimSummaryCardProps {
  title: string;
  value?: number | string;
  icon: React.ReactNode;
  isLoading?: boolean;
  valueClassName?: string;
  subtitle?: string;
}

export function SimSummaryCard({
  title,
  value,
  icon,
  isLoading,
  valueClassName,
  subtitle,
}: SimSummaryCardProps) {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          {icon}
        </div>
        {isLoading ? (
          <Skeleton className="mt-2 h-8 w-16" />
        ) : (
          <>
            <p className={`mt-2 text-2xl font-bold ${valueClassName || ''}`}>
              {value ?? 0}
            </p>
            {subtitle && (
              <p className="mt-0.5 text-xs text-muted-foreground">{subtitle}</p>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
